import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { Actions } from "../../components/actionsMenu/ActionsMenu";
import { useUser } from "../../api/useAuth";
import { ROLES } from "../../utils/constants";
import { differenceInHours } from "date-fns";

const ALLOWED_EDIT_ROLES = [ROLES.shilan, ROLES.admin, ROLES.tech_admin, ROLES.neurofeedback_director];

type ProtocolHeaderProps = {
    actions?: Actions;
};

export const ProtocolHeader = ({ actions }: ProtocolHeaderProps) => {
    const recordContext = useContext(RecordContext);
    const { data: user } = useUser();

    if (!recordContext) return null;

    const { client } = recordContext.item.treatment;
    const canEditUser = !!user?.role?.id && ALLOWED_EDIT_ROLES.includes(user.role.id);
    const dateCreated = recordContext.item.date_created;
    const isWithin24h = !dateCreated || differenceInHours(new Date(), new Date(dateCreated)) < 24;
    const canEdit = canEditUser || isWithin24h;

    return (
        <DetailHeader actions={actions} collection={recordContext.collection} editPermission={{ canEdit, tooltip: "Edição bloqueada após 24 horas" }}>
            <Grid container alignItems="flex-start" display="flex" flexWrap="nowrap" flexDirection="row" rowGap={5}>
                <Grid minWidth={300} xs={12} sm={6}>
                    <Typography variant="h6" color="secondary">
                        Protocolo de Neurofeedback
                    </Typography>
                    <Typography variant="h5" color="primary">
                        {client?.client_id}
                    </Typography>

                    <Typography variant="body1">
                        {client?.user_id?.first_name} {client?.user_id?.last_name}
                    </Typography>
                </Grid>
            </Grid>
        </DetailHeader>
    );
};
